import { GravyBinder } from "gravy-bind";
import reportValidity from 'report-validity';
import Inputmask, { Instance } from "inputmask/dist/inputmask";
import { IErrorValidator } from "./error-validator.interface";
import { formHasValue } from "./utils/form-has-value";
import { touchAllInputs } from "./utils/touch-all-inputs";

declare var window: any;

export class ClaimsSatisfaction implements IErrorValidator {
    public static htmlId = 'claims-satisfaction-survey';

    controls: Record<string, any> = {};
    binder!: GravyBinder;
    rootElement: HTMLFormElement;
    submitAttempted = false;

    public contactChoice!: string;
    public get desiresContact(): boolean {
        return this.contactChoice === 'True';
    }

    public recaptcha!: string;

    private phoneMask: Instance = new Inputmask({
        mask: '999-999-9999',
        autoTab: false
    });

    constructor(rootElement: HTMLElement) {
        this.rootElement = rootElement as HTMLFormElement;
        this.initialize();
    }

    public initialize = (): void => {

        this.binder = new GravyBinder(this, this.rootElement);
        this.binder.updateBindings();

        this.rootElement.addEventListener('submit', this.onSubmit);

        const host = this.rootElement.querySelector<HTMLElement>('md-outlined-text-field.phone-input');
        const inner = host?.querySelector<HTMLInputElement>('input');
        if (inner) {
            this.phoneMask.mask(inner);
        } else {
            console.warn("[WARN] phone-input inner <input> not found, mask not applied");
        }

        const up = this.rootElement.querySelector('.thumb-up');
        const down = this.rootElement.querySelector('.thumb-down');
        if (up) up.addEventListener('click', this.changeColor);
        if (down) down.addEventListener('click', this.changeColor);
    }

    public highlightError = (formInputName: string): boolean => {
        if (!this.submitAttempted) return false;
        return !formHasValue(this.rootElement, formInputName);
    }

    private onSubmit = (event: Event): void => {
        event.preventDefault();
        this.submitAttempted = true;

        this.binder.updateOutwardBindings();
        touchAllInputs(this.rootElement);

        this.rootElement.reportValidity();

        const isValid = this.rootElement.checkValidity();

        if (isValid && this.recaptcha) {
            this.rootElement.submit();
        } else {
        }
    }

    private changeColor = (event: Event): void => {
        const target = event.currentTarget as HTMLElement;
        const thumbUp = this.rootElement.querySelector<HTMLElement>('.thumb-up')!;
        const thumbDown = this.rootElement.querySelector<HTMLElement>('.thumb-down')!;
        const input = this.rootElement.querySelector<HTMLInputElement>("input[name=StronglyAgree]")!;

        if (target.classList.contains("thumb-up")) {
            input.value = "true";
            thumbUp.style.background = "green";
            thumbUp.style.color = "white";
            thumbDown.style.background = "white";
            thumbDown.style.color = "black";
        } else {
            input.value = "false";
            thumbUp.style.background = "white";
            thumbUp.style.color = "black";
            thumbDown.style.background = "red";
            thumbDown.style.color = "white";
        }
    }
}
